/** Modo de uso del artículo en el negocio. */
export type InventoryMode = 'sale' | 'rental';

/** Estado operativo del artículo. */
export type InventoryStatus =
  | 'available'
  | 'reserved'
  | 'in_use'
  | 'maintenance'
  | 'repair'
  | 'inspection'
  | 'sold'
  | 'inactive';

export type InventoryItem = {
  id: string;
  companyId: string;
  sku: string;
  name: string;
  description: string;
  categoryId: string;
  subcategoryId: string | null;
  mode: InventoryMode;
  status: InventoryStatus;
  customFieldValues: Record<string, unknown>;
  trackStock: boolean;
  stockQuantity: number;
  stockUnit: string;
  currentLocationId: string | null;
  lastMovementAt: string | null;
  lastInventoryCheckAt: string | null;
  createdAt: Date;
  updatedAt: Date;
};

export type InventoryItemInput = {
  sku: string;
  name: string;
  description: string;
  categoryId: string;
  subcategoryId: string | null;
  mode: InventoryMode;
  status: InventoryStatus;
  customFieldValues: Record<string, unknown>;
  trackStock: boolean;
  stockQuantity: number;
  stockUnit: string;
};

export const INVENTORY_MODE_LABELS: Record<InventoryMode, string> = {
  sale: 'Venta',
  rental: 'Alquiler',
};

export const INVENTORY_STATUS_LABELS: Record<InventoryStatus, string> = {
  available: 'Disponible',
  reserved: 'Reservado',
  in_use: 'En uso',
  maintenance: 'Mantenimiento',
  repair: 'Reparación',
  inspection: 'Inspección',
  sold: 'Vendido',
  inactive: 'Inactivo',
};

/** Campos legacy en Firestore (migración en lectura). */
export type LegacyItemFields = {
  purpose?: 'sale' | 'rental' | 'both';
  operationalStatus?: 'available' | 'reserved' | 'maintenance' | 'repair' | 'assigned';
  active?: boolean;
  mode?: InventoryMode;
  status?: InventoryStatus;
  currentLocationId?: string | null;
  lastMovementAt?: string | null;
  lastInventoryCheckAt?: string | null;
};

export function normalizeInventoryMode(data: LegacyItemFields): InventoryMode {
  if (data.mode === 'sale' || data.mode === 'rental') return data.mode;
  if (data.purpose === 'rental') return 'rental';
  return 'sale';
}

export function normalizeInventoryStatus(data: LegacyItemFields): InventoryStatus {
  if (data.status) return data.status;
  if (data.active === false) return 'inactive';
  switch (data.operationalStatus) {
    case 'assigned':
      return 'in_use';
    case 'available':
    case 'reserved':
    case 'maintenance':
    case 'repair':
      return data.operationalStatus;
    default:
      return 'available';
  }
}
